var exports = {
  "kL": "x2b2fbebb--e565be--container",
  "wx": "x2b2fbebb--e565be--header",
  "fi": "x2b2fbebb--e565be--column",
  "nu": "x2b2fbebb--e565be--fixed-footer",
  "Km": "x2b2fbebb--e565be--more-reviews",
  "qN": "x2b2fbebb--e565be--ratings-filter",
  "_A": "x2b2fbebb--e565be--tags",
};

module.exports = exports;
